import React from "react";
import PageWrapper from "../../components/Page/PageWrapper";
import FlagDetailsActions from "./FlagDetailsActions/FlagDetailsActions";
import PageTitle from "../../components/Page/PageTitle";
import FlaggedDataTable from "./components/FlaggedDataTable/FlaggedDataTable";
import { Grid } from "@mantine/core";
import ResolutionHistoryTable from "./components/ResolutionHistoryTable/ResolutionHistoryTable";
import ReviewStatusHistoryTable from "./components/ReviewStatusHistoryTable/ReviewStatusHistoryTable";
import RelatedDocumentsTable from "./components/RelatedDocumentsTable.jsx/RelatedDocumentsTable";
import { useTranslation } from "react-i18next";

const FlagDetails = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.flagDetails")} />
      <FlagDetailsActions />
      <FlaggedDataTable />
      <Grid m="md">
        <Grid.Col span={6}>
          <ResolutionHistoryTable />
        </Grid.Col>
        <Grid.Col span={6}>
          <ReviewStatusHistoryTable />
        </Grid.Col>
        <Grid.Col span={6}>
          <RelatedDocumentsTable />
        </Grid.Col>
      </Grid>
    </PageWrapper>
  );
};

export default FlagDetails;
